·
<template>
  <div class="container">
    <div class="form-w-320">
      <el-form ref="form" :model="form" :rules="rules" label-width="195px">
        <titleDom :title="'基础设置'" style="margin-bottom: 15px;"/>
        <div class="itemBox">
          <el-form-item label="网格员打卡范围设置" prop="check_in_scope">
            <el-input v-model="form.check_in_scope" placeholder="输入网格员打卡范围设置"
                      style="width: 320px"></el-input>
            <span style="margin-left: 12px;">米</span>
          </el-form-item>
        </div>
        <el-form-item label="产品外链URL白名单">
          <el-input v-model="link_url" placeholder="请输入需要添加为白名单的域名" style="width: 320px"></el-input>
          <el-button class="add-btn" @click="addUrlClick">添加</el-button>
          <div class="label-content flex flex-col-center" v-if="form.white_list_url.length>0">
            <span class="label-title">已添加</span>
            <el-tag v-for="tag in form.white_list_url" :key="tag" closable @close="labelClose(tag)">{{ tag }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="企业端评测问卷" prop="eval_question_id">
          <el-select style="width: 320px" v-model="form.eval_question_id" clearable placeholder="请选择问卷">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <p style="font-family: Microsoft YaHei;font-weight: 400;font-size: 12px;color: #6C7880;line-height: 36px;margin-left: 197px;margin-top: -15px">
          该问卷将作为企业端用户进行自主数转评测的填报问卷</p>
        <el-form-item label="企业端客服电话" prop="customer_service_mobile">
          <el-input v-model="form.customer_service_mobile" placeholder="请填写企业端用于联系平台的客服电话"
                    style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="background: #fff;" class="btn_box">
            <a class="blue" href="#" @click="submit">确定</a>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import titleDom from "@/components/common/titleDom.vue";
import {getQuestionnaireOptions} from "@/request/system";

export default {
  name: "Basics",
  components: {titleDom},
  data() {
    return {
      options: [],
      value: '',
      form: {
        check_in_scope: null,
        white_list_url: [],//
        eval_question_id: '',
        customer_service_mobile: ''
      },
      rules: {
        check_in_scope: [
          {required: true, message: '请输入网格员打卡范围设置', trigger: 'blur'},
          {pattern: /^[0-9]+$/, message: "请输入数字", trigger: "blur"}
        ],
        eval_question_id: [
          {required: true, message: '请选择问卷', trigger: 'change'}
        ],
        customer_service_mobile: [
          {required: true, message: '请填写企业端用于联系平台的客服电话', trigger: 'blur'},
        ],
      },
      link_url: ''
    }
  },
  mounted() {
    this.getBasis();

    this.$api.getQuestionnaireOptions().then(res => {
      this.options = res.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    })
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$api.editBasics(this.form).then(() => {
            this.$message({
              message: "更新成功",
              type: 'success'
            });
          })
        }
      });
    },
    getBasis() {
      this.$api.getBasics().then(res => {
        this.form = res.data;
      })
    },
    //添加URL
    addUrlClick() {
      if (!this.link_url) return this.$message({type: 'warning', message: '请输入需要添加为白名单的域名'});
      // this.$api.editBasics({check_in_scope: this.form.check_in_scope, white_list_url: this.link_url}).then(() => {
      this.form.white_list_url.push(this.link_url);
      this.link_url = '';
      // })
    },
    //删除标签
    labelClose(e) {
      this.form.white_list_url.splice(this.form.white_list_url.indexOf(e), 1);
    },
  },
}
</script>

<style lang="scss" scoped src="@/styles/common.scss"></style>
<style lang="scss" scoped>
.container {
  margin: 18px;
  padding: 30px 30px;
  width: calc(100% - 96px);
  height: calc(100% - 96px);
  background: #FFFFFF;
  overflow: scroll;
  scrollbar-width: none;

  .add-btn {
    width: 64px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #1C72F1;
    color: #1C72F1;
    margin-left: 10px;
    padding: 0;
  }

  .label-content {
    margin-top: 6px;

    .label-title {
      font-size: 12px;
      color: #242D33;
      margin-right: 14px;
    }

    .el-tag + .el-tag {
      margin-left: 10px;
    }
  }

  // 表单item样式修改
  ::v-deep .el-form-item {

    .el-form-item__error {
      top: 25%;
      left: 352px;
    }
  }
}
</style>